import { Box } from "@mui/material";
import { ComponentProps } from "../types";
import { CSSProperties, useContext, useMemo } from "react";
import DashboardComponent from "./DashboardComponent";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import DashboardPageContext from "../DashboardPageContext";

function Component({ component, evaluteScript }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const style = useMemo(() => {
		const style = {
			flexGrow: component.properties["flexGrow"] || 0,
			flexShrink: component.properties["flexShrink"] || 1,
			flexBasis: component.properties["flexBasis"] || "auto",
			alignSelf: component.properties["alignSelf"] || "auto",
		} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		if (component.properties["flex"]) style.flex = component.properties["flex"];
		if (component.properties["flexBox"] && component.properties["flexBox"] === "True") style.display = "flex";
		if (component.properties["width"]) style.width = component.properties["width"];
		if (component.properties["height"]) style.height = component.properties["height"];
		if (component.properties["minHeight"]) style.minHeight = component.properties["minHeight"];
		if (component.properties["maxHeight"]) style.maxHeight = component.properties["maxHeight"];
		return style;
	}, [component, exeMode]);
	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context, exeMode]);
	const componentStyles = useMemo(() => {
		try {
			if (component.styles) {
				const styles = typeof component.styles === "string" ? evaluteScript(component.styles) : component.styles;
				if (styles != undefined) return styles as CSSProperties;
			}
		} catch (error) {
			console.error(error);
		}
		return {} as CSSProperties;
	}, [component]);
	return (
		<Box sx={component.styles ? { ...style, ...componentStyles } : style} {...args}>
			{component.childern && component.childern.map((c, i) => <DashboardComponent key={i} component={c} />)}
		</Box>
	);
}

export default Component;
